'use client'

import type { ReactNode } from 'react'
import { TenantContext } from '@/utilities/TenantContext'

export default function TenantProvider({
  tenant,
  children,
}: {
  tenant: string
  children: ReactNode
}) {
  return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
}
